"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const verse_png_1 = __importDefault(require("../../../../../static/coins/verse.png"));
const styled_1 = require("./styled");
const AltPurchaseOptions = () => {
    return (react_1.default.createElement(styled_1.Wrapper, null,
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-alt-title" }),
        react_1.default.createElement(styled_1.StyledOption, { href: "https://verse.bitcoin.com", target: "_blank" },
            react_1.default.createElement(styled_1.Name, null,
                react_1.default.createElement("img", { src: verse_png_1.default, alt: "Verse DEX", height: 21, width: 21 }),
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-dex-title" })),
            react_1.default.createElement(styled_1.Description, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-dex-description" })))));
};
exports.default = AltPurchaseOptions;
//# sourceMappingURL=AltPurchaseOptions.js.map